import initialState from '../../../redux/initialState';
import {onAddNewItemToCart} from '../../CartPage/redux/cartPageActions';
import {setPartnerId} from '../../../logic/api.js';

export function openToCartPopup() {  
  return {
    type: 'TOCART:POPUP-OPEN'       
  };
}

export function closeToCartPopup() {  
  return {
    type: 'TOCART:POPUP-CLOSE'
  };
}

export function choosePartnerToCart(partnerId){
  setPartnerId(partnerId);
  return {
    type: 'TOCART:CHOOSE-PARTNER',
    chosenPartner: partnerId
  };
}

export function removePartnerToCart(){
  //TODO: setPartnerId(partnerId); remove Partner id <<<
  return {
    type: 'TOCART:REMOVE-PARTNER',
    chosenPartner: ''
  };
}

export const changeToCartItemQuantity = (toCartNewQuantity) => ({
  type: 'TOCART:CHANGE-ITEM-QUANTITY',
  toCartNewQuantity
});

export const changeToCartComment = (toCartPopupComment) => ({
  type: 'TOCART:CHANGE-COMMENT',
  toCartPopupComment
});

export const addItemToCart = (cartDetailItem) => (dispatch) => {
  dispatch({
    type: 'TOCART:ADD-ITEM-TOCART',
  });  

  dispatch(onAddNewItemToCart(cartDetailItem));//TODO: refactor this action creator !
  dispatch(choosePartnerToCart(cartDetailItem.partnerId));
};

export default function toCartPopupReducer(state = initialState.toCartPopupState, action) {  
  switch (action.type) {
    case 'TOCART:POPUP-OPEN':    
      return {
        ...state,
        isOpen: true
      };

    case 'TOCART:POPUP-CLOSE':    
      return {
        ...state,
        isOpen: false,
        toCartQuantity: 1
      };

    case 'TOCART:CHANGE-ITEM-QUANTITY': 
      return {
        ...state,
        toCartQuantity: action.toCartNewQuantity
      };

    case 'TOCART:ADD-ITEM-TOCART':
      return {
        ...state,
        isOpen: false,
        toCartQuantity: 1
      };

    case 'TOCART:CHOOSE-PARTNER':
      return {
        ...state,
        chosenPartner: action.chosenPartner
      };
      
    case 'TOCART:REMOVE-PARTNER':
      return {
        ...state,
        chosenPartner: action.chosenPartner
      };      

    case 'TOCART:CHANGE-COMMENT':      
      return {
        ...state,
        toCartPopupComment: action.toCartPopupComment
      };

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ToCartPopup/redux/toCartPopupActions.js
 **/